import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ParticipantProvider, useParticipant } from "@/context/ParticipantContext";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuthContext";
import { Toaster } from "@/components/ui/toaster";
import MainLayout from "@/components/MainLayout";

import Registration from "@/pages/Registration";
import Home from "@/pages/Home";
import TrainingManual from "@/pages/TrainingManual";
import ProductGuide from "@/pages/ProductGuide";
import Quiz from "@/pages/Quiz";
import Certificate from "@/pages/Certificate";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminParticipantDetail from "@/pages/AdminParticipantDetail";

function ParticipantProtectedRoute() {
  const { participant } = useParticipant();
  if (!participant) return <Navigate to="/" replace />;
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

function AdminProtectedRoute() {
  const { admin } = useAdminAuth();
  if (admin === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading...</div>;
  }
  if (admin === false) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}

function AppRoutes() {
  const { participant } = useParticipant();

  return (
    <Routes>
      <Route path="/" element={participant ? <Navigate to="/home" replace /> : <Registration />} />

      <Route element={<ParticipantProtectedRoute />}>
        <Route path="/home" element={<Home />} />
        <Route path="/training-manual" element={<TrainingManual />} />
        <Route path="/product-guide" element={<ProductGuide />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/certificate" element={<Certificate />} />
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<AdminProtectedRoute />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/participants/:id" element={<AdminParticipantDetail />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ParticipantProvider>
          <AdminAuthProvider>
            <AppRoutes />
            <Toaster />
          </AdminAuthProvider>
        </ParticipantProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
